module.exports = __webpack_public_path__ + "img/w11-cover.7160e93d.jpg";